import { render, staticRenderFns } from "./question-base.vue?vue&type=template&id=dbe03d98&scoped=true"
import script from "./question-base.vue?vue&type=script&lang=js"
export * from "./question-base.vue?vue&type=script&lang=js"
import style0 from "./question-base.vue?vue&type=style&index=0&id=dbe03d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe03d98",
  null
  
)

export default component.exports